// @ts-ignore
const VITE_API_URL = import.meta.env.VITE_API_URL;

export async function getHeaders() {
  const clientHeaders: Headers = new Headers();
  clientHeaders.append("Content-Type", "application/json");
  return clientHeaders;
}

export const getDomainDetails = async (config: any) => {
  try {
    const res = await fetch(
      `${VITE_API_URL}/engage/config?tid=${config.tid}&id=${config.id}`
    );
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const getGEOData = async () => {
  try {
    const res = await fetch(
      "https://pro.ip-api.com/json/?key=fyKFTSx0oBNG9O6&fields=proxy,hosting,isp,lat,long,zip,city,region,status,country,timezone,regionName,countryCode,query,org"
    );
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return {
      error: JSON.stringify(e)
    };
  }
};

export const getSessionDetails = async (config: any) => {
  try {
    const body = JSON.stringify({ ...config });
    const res = await fetch(`${VITE_API_URL}/engage/session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const getConversationHistory = async (payload: any) => {
  try {
    const body = JSON.stringify({ ...payload });
    const res = await fetch(`${VITE_API_URL}/engage/messages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const getConversations = async (payload: any) => {
  try {
    const body = JSON.stringify({ ...payload });
    const res = await fetch(`${VITE_API_URL}/engage/conversations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return [];
  }
};

export const getLastActiveConversation = async ({
  id,
  tid,
  mx_uid,
  mx_lim,
  mx_lis,
  mx_tdm,
  up_id,
  sender_type,
  conversation_purpose,
  current_time,
  time_zone,
  geo_data,
  current_page,
}: any) => {
  try {
    const body = JSON.stringify({
      id,
      tid,
      mx_uid,
      mx_lim,
      mx_lis,
      mx_tdm,
      up_id,
      sender_type,
      conversation_purpose,
      current_time,
      time_zone,
      geo_data,
      current_page,
    });
    const res = await fetch(`${VITE_API_URL}/engage/last-conversation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return [];
  }
};

export const createNewConversation = async ({
  id,
  tid,
  mx_uid,
  mx_lim,
  mx_lis,
  mx_tdm,
  up_id,
  sender_type,
  conversation_purpose,
  current_time,
  time_zone,
  geo_data,
  current_page,
}: any) => {
  try {
    const body = JSON.stringify({
      id,
      tid,
      mx_uid,
      mx_lim,
      mx_lis,
      mx_tdm,
      up_id,
      sender_type,
      conversation_purpose,
      current_time,
      time_zone,
      geo_data,
      current_page,
    });
    const res = await fetch(`${VITE_API_URL}/engage/conversation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error();
    }
    return data;
  } catch (e) {
    return null;
  }
};
